import type { TransitionService } from '@uirouter/angularjs';
import { upgradeExternalNg1Dependency } from '../common/ng1-upgrade-factory';

export const $transitionsToken = upgradeExternalNg1Dependency<TransitionService>('$transitions');
